import { yupResolver } from '@hookform/resolvers/yup';
import { FirebaseError } from 'firebase/app';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { firebaseAuth } from '../../firebase/firebase.service';
import { useFirebaseErrorHandler } from '../hooks/useFirebaseErrorHandler';

interface CreateAccountInputs {
  email: string;
  confirmEmail: string;
  password: string;
  confirmPassword: string;
}

const schema = yup
  .object({
    email: yup
      .string()
      .trim()
      .email(
        "L'email n'est pas valide, il doit être de la forme abc@example.com",
      )
      .required("L'email est requis"),
    confirmEmail: yup
      .string()
      .trim()
      .required("L'email de confirmation est requis")
      .oneOf([yup.ref('email')], 'Les emails ne correspondent pas'),
    password: yup
      .string()
      .trim()
      .min(6, 'Le mot de passe doit faire au moins 6 caractères')
      .matches(/\d/, 'Le mot de passe doit contenir au moins un chiffre')
      .required('Le mot de passe est requis'),
    confirmPassword: yup
      .string()
      .trim()
      .required('Le mot de passe de confirmation est requis')
      .oneOf([yup.ref('password')], 'Les mots de passe ne correspondent pas'),
  })
  .required();

export const useCreateAccount = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateAccountInputs>({
    resolver: yupResolver(schema),
  });
  const { handleFirebaseError } = useFirebaseErrorHandler();

  const onValid: SubmitHandler<CreateAccountInputs> = async (data) => {
    try {
      await createUserWithEmailAndPassword(
        firebaseAuth,
        data.email,
        data.password,
      );
      navigate('/dashboard');
    } catch (err) {
      const error = err as FirebaseError;
      handleFirebaseError(error);
    }
  };
  const onSubmit = handleSubmit(onValid);

  return { register, errors, onSubmit };
};
